<template>
    <div>
        <card-header title="Edit Session Track" icon="fa-pencil"/>

        <card-body>
            <track-form :track="track" />
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column">
                    <b-button type="is-warning is-outlined" size="is-small" @click="deleteTrack"><i class="far fa-trash-alt"></i><span class="ml-2" v-if="confirmDelete">Delete Track?</span></b-button>
                </div>
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!track.title"
                    ><i class="fas fa-check mr-2"></i>Save Session
                    </b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import {client as http} from '@/http_client';
    import moment from "moment";
    import TrackForm from "./TrackForm";

    export default {
        components: {TrackForm, CardFooter, CardToolbar, CardBody, CardHeader},
        props: ['card', 'props'],
        data() {
            return {
                conference: {},
                track: {},
                confirmDelete: false,
                dirty: null
            };
        },
        methods: {
            loadTrack: function() {
                console.log('loadTrack');
                this.$emit('loading', true);
                http.get('conferences/' + this.props.confId + '/tracks/' + this.props.trackId, {force: true}).then(response => {
                    this.track = response.data;
                    this.$emit('loading', false);
                }).catch(err => {

                });
            },
            submit: function() {
                http.put('conferences/' + this.props.confId + '/tracks/' + this.props.confId, this.track, {force: true}).then(response => {
                    this.$reloadCard('conf-tracks', {});
                    this.$saveAlert(false);
                    this.$closeCard(this.card);
                }).catch(err => {
                    window.alert('An error occurred while saving the track.');
                    this.$emit('loading', false);
                });
            },
            deleteTrack() {
                if (this.confirmDelete) {
                    this.$emit('loading', true);

                    http.delete('conferences/' + this.props.confId + '/tracks/' + this.props.confId).then(response => {
                        this.$reloadCard('conf-tracks', {});
                        this.$saveAlert(false);
                        this.$closeCard(this.card);
                    }).catch(err => {

                    });
                } else {
                    this.confirmDelete = true;
                    setTimeout(() => {
                        this.confirmDelete = false;
                    }, 3000);
                }
            }
        },
        watch: {
            'props.trackId': function() {
                this.dirty = null;
                this.loadTrack();
            },
            'session': {
                deep: true,
                handler: function() {
                    this.dirty = (this.dirty !== null);
                    if (!this.$TIER.saveAlert.active && this.dirty)
                        this.$saveAlert(true, 'Are you done editing this track? Unsaved changes will be lost.');
                }
            }
        },
        mounted() {
            this.loadTrack();
        }
    };
</script>
